import React, { memo, useCallback, useMemo} from "react";
import { Card, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, message } from "antd";
import {
  useGetAdminGetAllChannelsList,
  useGetAdminGetAllGroupsList,
  useGetAdminUsersList,
  useGetAuthorityFindCategory,
  useGetAuthorityFindRoles,
  usePostAuthorityAddNewAccess,
} from "core";
import LoadingView from "../../../atoms/loadingView";

const FIRSTENTITY = "firstEntity";
const SECONDENTITY = "secondEntity";
const FIRSTUSER = "user1";
const SECONDUSER = "user2";
const FIRSTROLE = "role1";
const SECOANDROLE = "role2";
const FirstCATEGORY="category1";
const SECOANDCATEGORY="category2"

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const CreateOperationalAccess = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();
  const { data: usersData} = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "2000",
  });
  const { data: rolesData} = useGetAuthorityFindRoles({pageNumber:'1',pageSize:'2000'});
  const { data: categoriesData} = useGetAuthorityFindCategory({pageNumber:"1",pageSize:"1000"});
  
  
  const methods = useForm({
    defaultValues: {
      firstEntity: "",
      secondEntity: "",
      user1: "",
      role1: "",
      user2: "",
      role2: "",
      category1:"",
      category2:"",
      authorities: [],
    },
  });
  const { handleSubmit, reset, watch } = methods;
  const _firstEntity = watch("firstEntity");
  const _secondEntity = watch("secondEntity");
  const { mutate, isPending } = usePostAuthorityAddNewAccess({
    onSuccess: () => {
      messageApi.open({
        type: "success",
        content: i18n.t("done"),
      });
      reset();
    },
  });

  const onSubmit = useCallback(
    ({
      user1,
      role1,
      user2,
      role2,
      category1,
      category2,
      authorities,
    }: {
      user1: string;
      role1: string;
      user2: string;
      role2: string;
      category1: any;
      category2:any;
      authorities: any;
    }) => {
      mutate({
        requestBody: {
          user1,
          role1,
          user2,
          role2,
          category1:Number(category1),
          category2:Number(category2),
          authorities,
        },
      });
    },
    []
  );

  const usersItem = useMemo((): any[] => {
    return usersData?.data?.users.map((item: any) => {
      return {
        value: item.userName,
        label: item?.nameAndFamily,
      };
    });
  }, [usersData]);

  const rolesItem = useMemo((): any[] => {
    return rolesData?.data?.roles?.map((item: any) => {
      return {
        value: item.name,
        label: item?.name,
      };
    });
  }, [rolesData]);

  const categoriesItem= useMemo((): any[] => {
    return categoriesData?.data?.categories?.map((item: any) => {
      return {
        value: item.id,
        label: item?.name,
      };
    });
  }, [categoriesData]);

 



  const firstEntityItem = [
    { label: i18n.t("user"), value: "user" },
    { label: i18n.t("role"), value: "role" },
    { label: i18n.t("category"), value: "category" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });

  const secoandEntityItem = [
    { label: i18n.t("user"), value: "user" },
    { label: i18n.t("role"), value: "role" },
    { label: i18n.t("category"), value: "category" },
  ]?.map((item) => {
    return {
      value: item.value,
      label: item.label,
    };
  });


  return (
    <>
    {contextHolder}
      <Card title={i18n.t("createOperationalAccess")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
             <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTENTITY}>
                <SelectBox
                  placeholder={i18n.t("firstEntity")}
                  label={i18n.t("firstEntity")}
                  options={firstEntityItem}
                />
              </Controller>
            </Form.Item>

            {_firstEntity === "user" && (
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTUSER}>
                  <SelectBox
                    // disabled={!Boolean(firstEntity)}
                    placeholder={i18n.t("firstUser")}
                    label={i18n.t("firstUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            )}

            {_firstEntity === "role" && (
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={FIRSTROLE}>
                  <SelectBox
                    placeholder={i18n.t("firstRole")}
                    label={i18n.t("firstRole")}
                    options={rolesItem}
                  />
                </Controller>
              </Form.Item>
            )}

          {_firstEntity === "category" && (
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={FirstCATEGORY}>
                  <SelectBox
                    placeholder={i18n.t("firstCategory")}
                    label={i18n.t("firstCategory")}
                    options={categoriesItem}
                  />
                </Controller>
              </Form.Item>
            )}

            

            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECONDENTITY}>
                <SelectBox
                  placeholder={i18n.t("SecondEntity")}
                  label={i18n.t("secondEntity")}
                  options={secoandEntityItem}
                />
              </Controller>
            </Form.Item>

            {_secondEntity=== "user" &&
              <Form.Item>
                <Controller rules={{ required: i18n.t('isRequired') }} name={SECONDUSER}>
                  <SelectBox
                    placeholder={i18n.t("secondUser")}
                    label={i18n.t("secondUser")}
                    options={usersItem}
                  />
                </Controller>
              </Form.Item>
            }
            {_secondEntity === "role" &&
            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECOANDROLE}>
                <SelectBox
                  placeholder={i18n.t("secondRole")}
                  label={i18n.t("secondRole")}
                  options={rolesItem}
                />
              </Controller>
            </Form.Item>}
            {_secondEntity === "category" &&
            <Form.Item>
              <Controller rules={{ required: i18n.t('isRequired') }} name={SECOANDCATEGORY}>
                <SelectBox
                  placeholder={i18n.t("secondCategory")}
                  label={i18n.t("secondCategory")}
                  options={categoriesItem}
                />
              </Controller>
            </Form.Item>}
        
            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("done")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
    </>
  );
});
export { CreateOperationalAccess };
